/**
 * Native delivery resource types are qualified by channel so the picker only
 * offers campaigns whose message matches the agent channel's medium. Kept
 * dependency-free so the app can import it alongside the UI definition.
 */
const NATIVE_DELIVERY_CAMPAIGN_RESOURCE_PREFIX = "campaign";

/**
 * Every agent campaign on the channel. Any number of flow messages can
 * deliver through one campaign, so the picker and the link resolve through
 * the same type.
 */
export function nativeDeliveryCampaignResourceType(
  channelType: string,
): string {
  return `${NATIVE_DELIVERY_CAMPAIGN_RESOURCE_PREFIX}:${channelType}`;
}

export function parseNativeDeliveryResourceType(
  type: string,
): { channelType: string } | null {
  const [prefix, channelType, ...rest] = type.split(":");
  if (
    prefix !== NATIVE_DELIVERY_CAMPAIGN_RESOURCE_PREFIX ||
    !channelType ||
    rest.length > 0
  ) {
    return null;
  }
  return { channelType };
}

/**
 * Liquid identifiers allow only word characters, so an agent variable name
 * like `first-name` becomes the template key `first_name`. Keep in sync with
 * the outbox loader, which applies the same fold when it projects
 * `sync_metadata.variables` onto fragment columns.
 */
export function toNativeDeliveryVariableKey(variableName: string): string {
  return variableName.replace(/[^a-zA-Z0-9_]/g, "_");
}
